module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/how-vux-loader-works-184.vue");


//////////////////
// WEBPACK FOOTER
// ./en/vux-loader/how-vux-loader-works.md
// module id = 624
// module chunks = 437